import { useTenantSettings } from "@nestoca/multi-tenant";
import { useBreakpointValue, Button, ButtonIcon } from "@nestoca/ui";
import { useTranslation } from "react-i18next";
import { PiPlus } from "react-icons/pi";

interface CreateAppButtonProps {
  setIsOpenApplicationsModalOpen: (isOpen: boolean) => void;
}

export const CreateAppButton = ({
  setIsOpenApplicationsModalOpen,
}: CreateAppButtonProps) => {
  const { t } = useTranslation("applications");

  const isMobile = useBreakpointValue({ default: true, md: false });

  const {
    enableNewApplicationCreate,
    enableGaq,
    cmaFormSettings: {
      settings: { showCreateNewApplication = true },
    },
  } = useTenantSettings();

  const showCreateAppButton =
    showCreateNewApplication &&
    enableGaq.value &&
    enableNewApplicationCreate.value;

  if (!showCreateAppButton) {
    return null;
  }

  if (isMobile) {
    return (
      <ButtonIcon
        aria-label={t("createApplicationButton")}
        onClick={() => setIsOpenApplicationsModalOpen(true)}
        variant="secondary"
        size="medium"
        data-dd-action-name="add new"
        icon={<PiPlus />}
      />
    );
  }

  return (
    <Button
      variant="secondary"
      size="medium"
      leftIcon={<PiPlus />}
      onClick={() => setIsOpenApplicationsModalOpen(true)}
    >
      {t("createApplicationButton")}
    </Button>
  );
};
